import { combineReducers } from "redux";

// slice
import banner from "./banner.slice";
import banner_product_category from "./banner-product-category.slice";

export default combineReducers({ banner,banner_product_category });
